/**
 * Top card shared by the Text Notes and Letter Upload tabs: the generated
 * document-name template and the status source field that drives PA status
 * bucketing.
 */
import { Select, TextInput } from "risa-oasis-ui_v2";
import { DELIVERY_STEP_FIELD_CONFIG } from "./deliveryStepFields";

// Use raw field names as labels so the select reads like the stored config value.
const STATUS_FIELD_OPTIONS = DELIVERY_STEP_FIELD_CONFIG.fields.map((f) => ({
  value: f.value,
  label: f.value,
}));

interface DocumentConfigCardProps {
  documentName: string;
  statusSourceField: string;
  onDocumentNameChange: (value: string) => void;
  onStatusSourceFieldChange: (value: string) => void;
}

/** Document name + status source field card. */
const DocumentConfigCard = ({
  documentName,
  statusSourceField,
  onDocumentNameChange,
  onStatusSourceFieldChange,
}: DocumentConfigCardProps) => (
  <div className="grid grid-cols-1 gap-4 rounded-lg border border-primaryGray-16 p-4 md:grid-cols-2">
    <TextInput
      id="delivery-document-name"
      label="Document name"
      placeholder="Pharmacy Authorization, {prior_auth_status}"
      defaultValue={documentName}
      onChange={(data: { value: string }) => onDocumentNameChange(data.value)}
    />
    <Select
      id="delivery-status-source-field"
      label="Status Source Field"
      options={STATUS_FIELD_OPTIONS}
      value={statusSourceField}
      defaultValue={statusSourceField}
      onOptionChange={(data: { value: string }) =>
        onStatusSourceFieldChange(data.value)
      }
      placeholder="Select status field..."
    />
  </div>
);

export default DocumentConfigCard;
